<template>
  <div>
    <div
      v-for="(message, i) in messages"
      :key="i"
      class="pega-sent-message"
      :class="{'pega-recieved-message': message.fromOthers}"
      :data-test="`message-${i}`"
    >
      <div class="boss-message-header-layout">
        <span data-test="send-date">{{ message.sendDate }}</span>
        <div class="boss-layout-block boss-message-when">
          差出人：<span data-test="sender-name">{{ message.senderInfo.name }}</span>
          <span data-test="semder-email">（{{ message.senderInfo.email }})</span>
        </div>
      </div>
      <div class="boss-layout-block">
        <div class="boss-message-mail-subject pega-word-break-break-word">
          TO：<span
            v-for="(to, index) in message.toReceivers"
            :key="`to-${index}`"
            :data-test="`to-${index}`"
          ><span data-test="to-name">{{ to.name }} </span>
            <span data-test="to-email">({{ to.email }}) </span></span><br>
          CC：<span
            v-for="(cc, index) in message.ccReceivers"
            :key="`cc-${index}`"
            :data-test="`cc-${index}`"
          ><span data-test="cc-name">{{ cc.name }} </span>
            <span data-test="cc-email">({{ cc.email }}) </span></span>
        </div>
        <div
          class="pega-pre-wrap pega-break"
          data-test="message-body"
          v-html="$sanitize(renderBody(message.body))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/lib/util'

export default {
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    renderBody (body) {
      return util.replaceAddressAndUrlLink(body)
    }
  }
}
</script>
